<template>
  <div class="chat-message clearfix">
    <textarea ref="messageInput"
              name="message-to-send"
              id="message-to-send"
              placeholder="Type your message "
              rows="3"
              v-model="inputtext"
              @input="input"
              @keydown.prevent.enter="keyenter"
              :disabled="disabled"></textarea>

    <div class="send">
      <a href="javascript:void(0)" @click="send">
        <img src="../assets/send.png">
      </a>
    </div>
  </div>
</template>
<script>
  import Global from "@/components/Global";
  import { MessageInputHandler } from "@/handler/MessageInputHandler.js";
  import store from "@/vuex/store_chat.js";

  export default {
    name: "message-input",

    data() {
      return {
        inputvalue: "",
        inputtext: ""
        //disabled: true
      };
    },
    created() {
      const thisComponent = this;
      this.$nextTick(() => {
        thisComponent.$refs.messageInput.focus();
      });

      // Global.proxy.on("checkSpeaker", speaker => {
      //   if (speaker.indexOf(Global.current_staffid) >= 0)
      //     return (this.disabled = false);
      //   else return (this.disabled = true);
      // });
    },
    computed: {
      disabled() {
        var flag = store.state.reload;
        var speaker = store.state.speaker;
        var isspeaker = speaker.indexOf(Global.current_staffid) >= 0;
        if (isspeaker) {
          return false;
        } else {
          return true;
        }
      }
    },
    methods: {
      input: function (val) {
        if (this.inputtext != this.inputvalue) {
          this.inputvalue = this.inputtext;
        }
      },
      send: function () {
        if (this.inputvalue.trim().length == 0) {
          return;
        }

        if (this.inputvalue.substr(this.inputvalue.length - 1, 1) == "\n") {
          this.inputvalue = this.inputvalue.substr(0, this.inputvalue.length - 1);
        }

        MessageInputHandler.submitMessage(this.inputvalue);
        this.inputtext = "";
        this.inputvalue = "";
      },
      keyenter(event) {
        if ($("#message-to-send").val() != this.inputvalue) {
          return;
        }

        const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        if (event.shiftKey || (isMobile && event.key === "Enter")) {  // shift, 或者手機上按 Enter 鍵, 當成換行, 不送出訊息 (MessageInput.vue這個元件似乎沒被用到)
          this.inputtext += "\n";
          return;
        } else {
          event.preventDefault();
        }

        if (this.inputvalue.trim().length == 0) {
          return;
        }

        if (this.inputvalue.substr(this.inputvalue.length - 1, 1) == "\n") {
          this.inputvalue = this.inputvalue.substr(0, this.inputvalue.length - 1);
        }
        MessageInputHandler.submitMessage(this.inputvalue);
        this.inputtext = "";
        this.inputvalue = "";
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/MessageInput.vue